@if (alwaysShown || ((!calendarProvider || showLocal || !calendarProvider.isLocal) && ((meetingCalendarIntegrationDismissed$ | async) === false || (oauthService.isAuthenticated$ | async) === true))) {
    <div class="alert alert-info pt-2 d-flex gap-3 align-items-end flex-wrap">
        <div class="flex-grow-1">
            <strong class="d-flex alert-heading mb-3 align-items-center">
                @if (!linkDisabled && calendarProvider && !calendarProvider.isLocal && oauthService.user) {
                    <a class="text-reset"
                       adaptTooltip="Click here to logout or switch accounts for this provider"
                       [routerLink]="personalConfigRoute?.path"
                       [queryParams]="{
                            section: ConfigArea[ConfigArea.CalendarIntegration],
                        }">Calendar integration</a>
                } @else {
                    Calendar integration
                }
                @if (!calendarProvider || !calendarProvider.isLocal) {
                    <i class="fal fa-info-circle ms-2"
                       adaptTooltip="Meetings will be sent to your nominated calendar provider."></i>
                }
                @if (isDismissible && (!calendarProvider || !calendarProvider.isLocal) && (oauthService.isAuthenticated$ | async) === false) {
                    <button adaptButton="closeBorderless"
                            adaptTooltip="Dismiss this prompt and don't show it again for all teams"
                            class="ms-auto"
                            (click)="dismissPrompt()"></button>
                }
            </strong>
            @if (showTextPrompt && !oauthService.user) {
                <p>{{ oauthService.getPromptText(true) }}</p>
            }
            <div [ngClass]="{
                    'd-flex justify-content-center': !oauthService.user,
                }">
                <adapt-calendar-provider-select [disabled]="disabled"
                                                [showDisableIntegration]="false"></adapt-calendar-provider-select>
            </div>
        </div>
        @if (contentTemplate) {
            <ng-container [ngTemplateOutlet]="contentTemplate"
                          [ngTemplateOutletContext]="{
                    $implicit: calendarProvider,
                    user: oauthService.user,
                }"></ng-container>
        }
    </div>
}
